// eslint-disable-next-line import/prefer-default-export
export function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}
//# sourceMappingURL=utils.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/date-picker/utils.js
// module id = 332
// module chunks = 0